/**
 * Компактные подписи переключателей языка и валюты в шапке.
 *
 * Тема выводит на кнопках полные названия: «English» и «Canada (CAD $)».
 * В шапке это занимает много места, особенно на мобильных. Здесь подписи
 * сокращаются до кода языка («EN») и кода валюты («CAD»); флаг страны
 * и стрелка остаются как есть.
 *
 * Почему скриптом, а не правкой сниппетов. snippets/language-selector.liquid
 * и country-selector.liquid — файлы вендора, и они же используются в подвале
 * и в мобильном меню, где место есть и полные названия уместнее. Копировать
 * их себе значит завести две версии одной разметки и ловить расхождения при
 * каждом обновлении темы.
 *
 * Меняются только текстовые узлы внутри кнопки: разметка, обработчики и
 * список вариантов не трогаются. Если вендор изменит разметку и селекторы
 * перестанут совпадать, подписи просто останутся полными — ничего не сломается.
 */
(function () {
  'use strict';

  function shortLanguage() {
    var code = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    return String(code).slice(0, 2).toUpperCase();
  }

  function shortCurrency() {
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return cur ? String(cur).toUpperCase() : '';
  }

  /** Заменяет видимый текст кнопки, не трогая вложенные элементы. */
  function replaceLabel(button, text) {
    if (!button || !text) return;
    var replaced = false;
    button.childNodes.forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      if (!node.textContent.trim()) return;
      node.textContent = replaced ? '' : ' ' + text + ' ';
      replaced = true;
    });
  }

  function compact(root) {
    root.querySelectorAll('[data-disclosure-toggle]').forEach(function (button) {
      var controls = button.getAttribute('aria-controls') || '';
      if (controls.indexOf('lang') !== -1) replaceLabel(button, shortLanguage());
      else if (controls.indexOf('country') !== -1) replaceLabel(button, shortCurrency());
    });
  }

  function boot() {
    document.querySelectorAll('.header__localization').forEach(compact);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Пересборка шапки в редакторе темы.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.header__localization').forEach(compact);
  });
})();
